module.exports = __webpack_public_path__ + "f8b64af97ae10a589f8be140191a3f61.png";